<template>
  <div class="detalhe-unidade">
    <div class="row">
      <PublicHeader :title="nomeUnidade">
        <div class="col-xs-12 col-sm-6">
          <p>
            <span class="label">Endereço:</span>
            {{ infoEndereco }}
          </p>
          <p>
            <span class="label">Telefone:</span>
            {{ infoTelefone }}
          </p>
          <p>
            <span class="label">Atendimento:</span>
            {{ infoUnidade }}
          </p>
        </div>
        <div class="col-xs-12 col-sm-6" v-if="coordenadas.lat">
          <OpenMap
            :latitute="coordenadas.lat"
            :longitude="coordenadas.lng"
            :zoom="zoom"
            :pins="pins"
            :icon="icon"
            :popupPoint="popupPoint"
          />
        </div>
      </PublicHeader>
    </div>
    <div class="row">
      <div class="container">
        <Breadcrumb :links="breadcrumb" />
        <div v-if="remedio.principio_ativo" class="row">
          <div class="col-xs-12 form-group" v-if="remedio.orientacao">
            <CriterioRemedio :remedio="remedio" />
          </div>
          <div class="col-xs-12">
            <p class="font-lg">
              Além do item
              <span class="destaque">
                {{ remedio.principio_ativo }}
              </span>
              , veja outros itens disponíveis nesta unidade.
            </p>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-xs-12">
            <h3>
              Lista de medicamentos da unidade
            </h3>
          </div>
        </div>
        <div v-if="carregando.listaMedicamentos" class="row">
          <div class="col-xs-12 text-center">
            <font-awesome-icon
              :icon="'spinner'"
              size="3x"
              spin
            ></font-awesome-icon>
          </div>
        </div>
        <div v-else class="row form-group">
          <div class="col-xs-12 col-sm-6">
            <Label>Pesquisar na lista</Label>
            <input
              ref="filtro-medicamentos"
              type="tex"
              class="form-control input-pesquisar"
              placeholder="Digite sua busca..."
              v-model="termoFiltro"
            />
          </div>
        </div>
        <div class="row" v-if="!carregando.listaMedicamentos">
          <div
            class="col-xs-12"
            v-for="(medicamento, index) in disponiveisUnidadeFiltered"
            :key="
              `${medicamento.principio_ativo}-${medicamento.id_princ_ativo}-${medicamento.cota}`
            "
          >
            <div
              :class="[
                index % 2 === 0 ? 'background-dark' : 'background-light',
                'font-lg',
                'padding-table',
                isUnavailable(medicamento) ? 'indisponivel' : ''
              ]"
            >
              <p
                :class="[
                  'table-remedio',
                  medicamento.orientacao ? 'espacamento' : ''
                ]"
              >
                <router-link
                  :to="{
                    name: 'unidades-remedio',
                    params: {
                      principio: medicamento.principio_ativo
                    }
                  }"
                >
                  {{ medicamento.principio_ativo }}
                </router-link>
                <span v-if="isUnavailable(medicamento)">
                  - Indisponível no momento
                </span>
              </p>
              <p
                v-if="medicamento.portaria === '344/98'"
                class="table-remedio orientacao"
              >
                Medicamento Controlado - Portaria 344/98
              </p>
              <p
                v-if="medicamento.portaria === '471/2021'"
                class="table-remedio orientacao"
              >
                Medicamento Antimicrobiano - RDC 471/2021
              </p>
              <p
                class="table-remedio orientacao espacamento"
                v-if="medicamento.orientacao"
                v-html="getDescricaoOrientacao(medicamento)"
              ></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  PublicHeader,
  Breadcrumb,
  CriterioRemedio,
  OpenMap
} from '../../../components'
import { request } from '../../../request'
import {
  latLong,
  latLongGroup,
  capitalize,
  capitalizeEachWord
} from '../../../utils'

export default {
  components: {
    PublicHeader,
    Breadcrumb,
    CriterioRemedio,
    OpenMap
  },
  beforeCreate() {
    const { remedio, detalhes } = this.$route.params
    if (!remedio && !detalhes) {
      this.$router.push('/aqui-tem-remedio')
    }
  },
  async created() {
    const {
      remedio,
      unidade,
      detalhes,
      unidadesComRemedio
    } = this.$route.params

    if (unidade) {
      this.unidade = unidade
    } else {
      this.unidade.unidade_saude = detalhes.replace(/\(-\)/g, '.')
    }

    this.unidadesComRemedio = unidadesComRemedio || []

    this.getPosicaoMapa()

    this.remedio = remedio || {}
    await this.getRemediosUnidade()
  },
  data() {
    return {
      carregando: {
        infoAtendimento: false,
        listaMedicamentos: false
      },
      remedio: {},
      unidade: {
        email: '',
        apelido: '',
        endereco_completo: '',
        telefone: '',
        observacao: ''
      },
      // informacoesUnidade: {},
      disponiveisUnidade: [],
      unidadesComRemedio: [],
      termoFiltro: '',
      coordenadas: {},
      zoom: 16,
      pins: [],
      icon: undefined,
      popupPoint: undefined
    }
  },
  methods: {
    capitalizeEachWord,
    async getPosicaoMapa() {
      const { lat, lng, nome } = await latLong(
        this.unidade.unidade_saude,
        this.$store
      )

      if (this.unidadesComRemedio.length) {
        const nomesUnidades = this.unidadesComRemedio.map((unidade, index) => {
          return {
            unidade_saude: unidade.unidade_saude,
            disponivel: Number(unidade.saldo) > 0
          }
        })

        this.pins = await latLongGroup(nomesUnidades, this.$store)
      } else {
        const { localizacao_unidades } = this.$store.state

        const pins = localizacao_unidades.unidades.map(unidade => {
          return {
            position: unidade.position,
            title: unidade.nome_mv
          }
        })

        this.pins = [...pins]
      }

      this.coordenadas = { lat, lng }

      if (nome === 'santos-default') this.zoom = 10
    },
    isUnavailable(remedio) {
      const disponibilidade = Number(remedio.saldo) === 0
      return disponibilidade
    },
    getDescricaoOrientacao(remedio) {
      return CriterioRemedio.methods.getDescricaoOrientacao(remedio)
    },
    toggleLoading(key) {
      this.carregando[key] = !this.carregando[key]
    },
    async getRemediosUnidade() {
      this.toggleLoading('listaMedicamentos')
      await request
        .get('remedios/unidades/disponiveis', {
          params: {
            unidade_saude: this.unidade.unidade_saude
          }
        })
        .then(response => {
          const { data } = response
          this.disponiveisUnidade = data

          if (!this.unidade.email) {
            const [first] = data
            this.unidade.email = first.email
            this.unidade.bairro = first.bairro
            this.unidade.endereco_completo = first.endereco_completo
            this.unidade.endereco_nr = first.endereco_nr
            this.unidade.telefone = first.telefone
            this.unidade.apelido = first.apelido
            this.unidade.observacao = first.observacao
          }
        })
        .catch(error => {
          console.log(error.response)
        })
        .finally(() => this.toggleLoading('listaMedicamentos'))
    }
  },
  computed: {
    breadcrumb() {
      const links = [{ label: 'Remédio Fácil', link: '/remedio-facil' }]

      if (this.remedio.principio_ativo) {
        links.push({
          label: this.remedio.principio_ativo,
          named_link: {
            name: 'unidades-remedio',
            params: {
              principio: this.remedio.principio_ativo,
              remedio: this.remedio
            }
          }
        })
      }

      links.push({ label: this.unidade.unidade_saude })

      return links
    },
    nomeUnidade() {
      return this.unidade.apelido || this.unidade.unidade_saude
    },
    infoEmail() {
      const email = this.unidade.email
      return email ? email.toLowerCase() : '----------'
    },
    infoTelefone() {
      return this.unidade.telefone || '----------'
    },
    infoUnidade() {
      return this.unidade.observacao
        ? capitalize(this.unidade.observacao.toLowerCase())
        : '----------'
    },
    infoEndereco() {
      return this.unidade.endereco_completo
        ? capitalizeEachWord(this.unidade.endereco_completo.toLowerCase())
        : '----------'
    },
    disponiveisUnidadeFiltered() {
      const filter = item =>
        item.principio_ativo
          .toLowerCase()
          .includes(this.termoFiltro.toLowerCase())
      return this.disponiveisUnidade.filter(filter)
    }
  }
}
</script>

<style scoped>
.background-dark {
  background-color: #e1e1e1;
}
.background-light {
  background-color: #f1f1f1;
}
.padding-table {
  padding: 5px;
  position: inherit;
  transition: 200ms ease;
}

.shadow {
  box-shadow: 0px 0px 10px 1px #00302e;
}

.padding-table:hover {
  -webkit-transform: scale(1.05, 1.1);
  -ms-transform: scale(1.05, 1.1);
  transform: scale(1.05, 1.1);
  box-shadow: 0 0 5px #00302e, 0px 0px 0px 1px #00302e;
  /* box-shadow: 0px 0px 5px #00302e; */
  z-index: 1;
}

p.table-remedio {
  margin: 0px;
  padding: 0px 5px;
}

p.color-default {
  color: #697473;
}

p.orientacao {
  color: #00615c;
}

.indisponivel {
  color: #ff3860;
}

p.espacamento {
  margin-bottom: 15px;
}

@media (max-width: 767px) {
  .input-pesquisar {
    height: 50px;
    font-size: 1.5em;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/public/remedios/DetalheUnidade.vue